<div class="ops-container">
    <div class="top-row">
        <div class="name-container">
            <mat-icon
                data-cy="sys-status-ops-icon"
                svgIcon="status-indicator"
                [ngClass]="{
                    alarm_status: hasAlarms() && isReceivingData,
                    disconnected_status: !isReceivingData,
                    stable_status: !hasAlarms() && isReceivingData,
                }"
            />
            {{ "system-status.page-title.ops" | translate }}
            {{ " " + (index + 1) }}
        </div>
        <div class="location-container">
            <mat-icon svgIcon="location_on" />
            {{ ops.location }}
        </div>
    </div>
    <div class="status-container">
        <div
            class="status-wrapper"
            [ngClass]="{
                'alarm-font': getIcon(ops.initialized) === 'status-error',
            }"
        >
            {{ "system-status.ops.initialized" | translate }}
            <mat-icon
                *ngIf="isReceivingData"
                data-cy="sys-status-ops-init-icon"
                svgIcon="{{ getIcon(ops.initialized) }}"
                class="icon"
            />
            <div *ngIf="!isReceivingData" class="disconnected-line"></div>
        </div>
        <div
            class="status-wrapper"
            [ngClass]="{
                'alarm-font': getIcon(ops.ethernetA) === 'status-error',
            }"
        >
            {{ "system-status.ops.ethernetA" | translate }}
            <mat-icon
                *ngIf="isReceivingData"
                data-cy="sys-status-ops-ethernet-a-icon"
                svgIcon="{{ getIcon(ops.ethernetA) }}"
                class="icon"
            />
            <div *ngIf="!isReceivingData" class="disconnected-line"></div>
        </div>

        <div
            class="status-wrapper"
            [ngClass]="{
                'alarm-font': getIcon(ops.ethernetB) === 'status-error',
            }"
        >
            {{ "system-status.ops.ethernetB" | translate }}
            <mat-icon
                *ngIf="isReceivingData"
                data-cy="sys-status-ops-ethernet-b-icon"
                svgIcon="{{ getIcon(ops.ethernetB) }}"
                class="icon"
            />
            <div *ngIf="!isReceivingData" class="disconnected-line"></div>
        </div>
        <div
            class="status-wrapper"
            [ngClass]="{
                'alarm-font': getIcon(ops.server) === 'status-error',
            }"
        >
            {{ "system-status.ops.server" | translate }}
            <mat-icon
                *ngIf="isReceivingData"
                data-cy="sys-status-ops-server-icon"
                svgIcon="{{ getIcon(ops.server) }}"
                class="icon"
            />
            <div *ngIf="!isReceivingData" class="disconnected-line"></div>
        </div>
        <div
            class="status-wrapper"
            [ngClass]="{
                'alarm-font': getIcon(ops.database) === 'status-error',
            }"
        >
            {{ "system-status.ops.database" | translate }}
            <mat-icon
                *ngIf="isReceivingData"
                data-cy="sys-status-ops-database-icon"
                svgIcon="{{ getIcon(ops.database) }}"
                class="icon"
            />
            <div *ngIf="!isReceivingData" class="disconnected-line"></div>
        </div>
        <div
            class="status-wrapper"
            [ngClass]="{
                'alarm-font': getIcon(ops.remote) === 'status-error',
            }"
        >
            {{ "system-status.ops.remote" | translate }}
            <mat-icon
                *ngIf="isReceivingData"
                data-cy="sys-status-ops-remote-icon"
                svgIcon="{{ getIcon(ops.remote) }}"
                class="icon"
            />
            <div *ngIf="!isReceivingData" class="disconnected-line"></div>
        </div>
    </div>
    <div *ngIf="ops.current" style="display: flex; justify-content: flex-end">
        <div class="current-container">
            <mat-icon svgIcon="monitor" class="monitor-icon" />
            {{ "system-status.ops.current" | translate }}
        </div>
    </div>
</div>
